import {
  Time,
  TimeCreate,
  timeSchema,
  timesSchema,
  TimeUpdate,
} from "@companies/shared/types/time";

import { FETCH_ERROR } from "../consts/fetch-error";
import { dateFormat } from "../utils/date-format";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getTimes(
  input: ({ from: Date; to: Date } | { date: Date }) & { project?: string },
): Promise<Time[]> {
  const queryParams = `${
    "date" in input
      ? `date=${dateFormat(input.date)}`
      : `from=${dateFormat(input.from)}&to=${dateFormat(input.to)}`
  }${input.project ? `&project=${encodeURIComponent(input.project)}` : ""}`;
  const response = await fetch(`${API_BASE_URL}/time?${queryParams}`);

  if (response.status === 401) {
    throw FETCH_ERROR.UNAUTHORIZED;
  } else if (!response.ok) {
    throw new Error("Failed to get times");
  }

  return timesSchema.parse(await response.json());
}

export async function getTime(id: string): Promise<Time> {
  const response = await fetch(`${API_BASE_URL}/time/${id}`);

  if (response.status === 401) {
    throw FETCH_ERROR.UNAUTHORIZED;
  } else if (!response.ok) {
    throw new Error("Failed to get time");
  }

  return timeSchema.parse(await response.json());
}

export async function createTime(time: TimeCreate) {
  const response = await fetch(`${API_BASE_URL}/time`, {
    method: "POST",
    body: JSON.stringify(time),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (response.status === 401) {
    throw FETCH_ERROR.UNAUTHORIZED;
  } else if (!response.ok) {
    throw new Error("Failed to create time");
  }

  return timeSchema.parse(await response.json());
}

export async function updateTime(id: string, time: TimeUpdate) {
  const response = await fetch(`${API_BASE_URL}/time/${id}`, {
    method: "PATCH",
    body: JSON.stringify(time),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (response.status === 401) {
    throw FETCH_ERROR.UNAUTHORIZED;
  } else if (!response.ok) {
    throw new Error("Failed to update time");
  }

  return timeSchema.parse(await response.json());
}

export async function deleteTime(id: string) {
  const response = await fetch(`${API_BASE_URL}/time/${id}`, {
    method: "DELETE",
  });

  if (response.status === 401) {
    throw FETCH_ERROR.UNAUTHORIZED;
  } else if (!response.ok) {
    throw new Error("Failed to delete time");
  }
}
